export const isBeta = !!process.env.REACT_APP_BETA_MODE
